var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"a-floor-info floor-info"},[_vm._v(" "+_vm._s(_vm.props.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }